import React from "react";
import {
  Typography,
  Button,
  Menu,
  Input,
  Form,
  Switch,
  Radio,
  Space,
  Select,
  Tooltip,
  Popconfirm,
} from "antd";
import Utils from "./utils";
import Lottie from "react-lottie";
import * as animationData from "./ComingSoon.json";
import { IoIosWarning } from "react-icons/io";
const { Option } = Select;
const { Text } = Typography;
const { AccessTypeBox, PermissionTypeBox, LineBreak, LabelRow } = Utils;

export const InfoBox = () => {
  return (
    <div
      style={{
        borderRadius: 4,
        backgroundColor: Utils.Colors.adminTabColor,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: 80,
      }}
    >
      <AccessTypeBox
        isAdmin={true}
        styles={{ marginLeft: 20, width: "40px", height: "40px" }}
        iconSize="1.5rem"
      />

      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          height: 80,
          marginLeft: 10,
        }}
      >
        <div style={{ fontSize: "14px", color: "#1D2624" }} strong>
          Admin Access
        </div>
        <div style={{ color: "#828786", fontSize: "14px" }}>
          Admins have full control on the platform on all modules
        </div>
      </div>
    </div>
  );
};

export const SwitchBox = ({ isAdmin, isToggle, handleToggleAccess }) => {
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <AccessTypeBox
        isAdmin={isAdmin}
        styles={{ width: "40px", height: "40px" }}
        iconSize="1.5rem"
      />
      <div
        style={{
          paddingLeft: "1rem",
          paddingRight: "1rem",
          paddingBottom: "0.3rem",
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        <div
          style={{
            marginBottom: "1.5rem",
            flexDirection: "column",
            display: "flex",
          }}
        >
          <Text style={{ fontSize: "16px", color: "#1D2624" }} strong>{`${
            isAdmin ? "Admin" : "Employee"
          } Access`}</Text>
          <Text style={{ color: "#828786", fontSize: "14px" }}>
            {isAdmin
              ? "Admins have full control on the platform on all modules"
              : "You can manage and give different level of permissions"}
          </Text>
        </div>
      </div>
      <Switch
        checked={isToggle}
        onChange={() =>
          handleToggleAccess(!isToggle, isAdmin ? "admin" : "employee")
        }
        name={isAdmin ? "admin" : "employee"}
        defaultChecked={false}
      />
    </div>
  );
};

const CustomItem = ({ id, onClick, label, isActive, index }) => {
  return (
    <div
      className="custom_menu"
      style={{
        color: isActive ? "#278977" : "rgb(0,0,0,0.85)",
        borderBottom: isActive ? "2px solid #278977" : 0,
      }}
      onClick={() => {
        onClick(id);
      }}
    >
      {label}
    </div>
  );
};
export const ModalHeader = ({ headerTabKey, handleTabChange, modalType }) => {
  const l1 = modalType === "add" ? "Details" : "Edit Details";
  const l2 = modalType === "add" ? "User permissions" : "Edit User permissions";
  const tabs = [
    {
      key: "1",
      label: l1,
    },
    {
      key: "2",
      label: l2,
    },
  ];
  return (
    <>
      <Menu
        selectedKeys={headerTabKey}
        mode="horizontal"
        theme="light"
        inlineIndent={1}
        style={{ backgroundColor: "white", marginBottom: "1rem" }}
        className="header-menu"
      >
        {tabs.map((item, index) => {
          return (
            <CustomItem
              key={item.key}
              id={item.key}
              onClick={handleTabChange}
              label={item.label}
              isActive={headerTabKey === item.key}
              index={index}
            />
          );
        })}
      </Menu>
    </>
  );
};

export const ModalSubHeader = ({ modalType, email }) => {
  const str =
    modalType === "edit"
      ? `Update details and permissions for ${email}`
      : "Add users to the platform and define their permissions of usage";
  return <Text style={{ color: "#4F5655" }}>{str}</Text>;
};

export const FooterButtons = ({
  handleCancel,
  handleAction,
  actionButtonLabel,
  cancelButtonLabel,
  loading,
  buttonLoader,
  styles = {},
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Button
        style={{
          border: "1px solid #363E3D",
          color: "#363E3D",
          width: 170,
          height: 40,
          ...styles,
        }}
        onClick={handleCancel}
      >
        {cancelButtonLabel}
      </Button>
      <Button
        style={{
          background: "#363E3D",
          color: "white",
          border: 0,
          width: 170,
          height: 40,
          ...styles,
        }}
        onClick={handleAction}
        loading={buttonLoader}
      >
        {actionButtonLabel}
      </Button>
    </div>
  );
};

export const SideBarCard = ({
  counts,
  type,
  isActive,
  onClick,
  id,
  modalType,
}) => {
  const { label, color } = Utils.getSidebarAccessTags(
    counts,
    modalType,
    isActive
  );
  return (
    <div
      onClick={() => onClick(id)}
      style={{
        cursor: "pointer",
        marginBottom: 15,
        borderRadius: 4,
        display: "flex",
        flexDirection: "row",
        padding: 10,
        backgroundColor: isActive ? type.tabColor : "#F5F5F5",
      }}
    >
      <PermissionTypeBox
        iconColor={isActive ? type.iconColor : "#B4B7B6"}
        iconSize="1.5rem"
        iconBgColor={isActive ? type.iconBgColor : "#FFFFFF"}
        name={type.permissionType}
        styles={{ width: "40px", height: "40px" }}
      />
      <div style={{ marginLeft: 10 }}>
        <div
          style={{ fontSize: 16 }}
        >{`${type.permissionType} permissions`}</div>
        <div style={{ fontSize: 14, color }}>{label}</div>
      </div>
    </div>
  );
};

export const CustomSideBar = ({
  modalType,
  totalCountPerCategory,
  activeKey,
  data,
  types,
  tabChange,
  allPermissions,
}) => {
  return (
    <div style={{ flexDirection: "column", display: "flex" }}>
      {data.map((category, index) => {
        const obj = {
          ...types[category.type],
          permissionType: category.type,
        };
        const key = (index + 1).toString();
        return (
          <SideBarCard
            key={`${category.type}_side_card`}
            onClick={tabChange}
            type={obj}
            isActive={activeKey === key}
            id={key}
            counts={totalCountPerCategory[category.type]}
            modalType={modalType}
          />
        );
      })}
    </div>
  );
};

export const UserScreenOne = ({
  isAdmin,
  handleToggleAccess,
  currentUser,
  modalType,
  countryCodes,
}) => {
  const prefixSelector = (
    <Form.Item name="country" style={{ marginBottom: 0 }}>
      <Select
        dropdownAlign={{ points: ["bl", "tl"] }}
        allowClear
        className="country_codes_select"
        showSearch
        style={{ width: 130 }}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          optionA.children
            .toLowerCase()
            .localeCompare(optionB.children.toLowerCase())
        }
        defaultValue={currentUser?.country?.id}
      >
        {countryCodes.map((item) => {
          return (
            <Option
              value={item.id}
            >{`${item.iso3}+(${item.phonecode})`}</Option>
          );
        })}
      </Select>
    </Form.Item>
  );

  const myself =
    currentUser.userId === JSON.parse(localStorage.getItem("userId"));
  return (
    <div style={{ overflowY: "scroll", height: 440 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <Form.Item
          style={{ flexGrow: 1, paddingRight: "0.5rem" }}
          label="First name"
          name="first_name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          style={{ flexGrow: 1, paddingLeft: "0.5rem" }}
          label="Last name"
          name="last_name"
        >
          <Input />
        </Form.Item>
      </div>
      <Form.Item label="Email ID" name="email">
        <Input disabled={modalType === "edit"} />
      </Form.Item>
      {modalType === "add" && (
        <Form.Item label="Password" name="password">
          <Input.Password />
        </Form.Item>
      )}
      {modalType === "edit" && (
        <Form.Item label="Password" name="password">
          <Input type="password" placeholder="Password" disabled />
        </Form.Item>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <Form.Item
          style={{ flexGrow: 1, paddingRight: "0.5rem" }}
          label="Mobile number (Optional)"
          name="mobile"
        >
          <Input
            onWheel={(e) => e.currentTarget.blur()}
            addonBefore={prefixSelector}
            type="number"
          />
        </Form.Item>
      </div>

      {myself && <InfoBox />}
      {!myself && (
        <Form.Item label="Select access type">
          <SwitchBox
            isAdmin={true}
            isToggle={isAdmin}
            handleToggleAccess={handleToggleAccess}
          />

          <SwitchBox
            isAdmin={false}
            isToggle={!isAdmin}
            handleToggleAccess={handleToggleAccess}
          />
        </Form.Item>
      )}
    </div>
  );
};

export const AdminPermissionsScreen = ({ data, types }) => {
  const renderRow = (row) => {
    const type = types[row.permissionType];
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <PermissionTypeBox
          iconColor={type.iconColor}
          iconSize="1.5rem"
          iconBgColor={type.iconBgColor}
          name={row.permissionType}
          styles={{ width: "40px", height: "40px", marginTop: 2 }}
        />
        <div
          style={{
            paddingLeft: "1rem",
            paddingRight: "1rem",
            justifyContent: "space-between",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <div
            style={{
              flexDirection: "column",
              display: "flex",
            }}
          >
            <div
              style={{ color: "#1D2624", paddingBottom: 12, fontWeight: 800 }}
            >{`${row.permissionType} permissions`}</div>
            {row.info.map((i) => {
              return (
                <Text style={{ paddingBottom: 8, color: "#363E3D" }}>{i}</Text>
              );
            })}
          </div>
        </div>
        <Text style={{ color: "#040E0C" }} strong>
          Full Access
        </Text>
      </div>
    );
  };
  return (
    <div>
      {data.map((row, index) => {
        const isLastIndex = data.length === index + 1;
        return (
          <>
            {renderRow(row)}
            {!isLastIndex && <LineBreak size="1rem" />}
          </>
        );
      })}
    </div>
  );
};

const RadioType = ({
  subPermission,
  toggleValue,
  permissionId,
  handleSubPermission,
  values,
  hasCataloguePermissions,
}) => {
  return (
    <Radio.Group disabled={!toggleValue} value={values[0]}>
      <Space direction="vertical">
        {subPermission.defaults.map((option) => {
          if (option.value === "current_user" && hasCataloguePermissions) {
            return (
              <Popconfirm
                placement="topLeft"
                style={{
                  boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.12)",
                }}
                onConfirm={(e) => {
                  handleSubPermission(
                    ["current_user"],
                    permissionId,
                    subPermission.type
                  );
                }}
                okText="Confirm"
                cancelText="Cancel"
                icon={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <IoIosWarning size={20} color="#FFB34D" />{" "}
                    <div
                      style={{ fontWeight: 700, fontSize: 14, marginLeft: 5 }}
                    >
                      User will loose access to all catalogues
                    </div>
                  </div>
                }
              >
                <Radio
                  key={`${option.value}_option`}
                  onChange={(e) => {}}
                  value={option.value}
                >
                  {option.label}
                </Radio>
              </Popconfirm>
            );
          }
          return (
            <Radio
              key={`${option.value}_option`}
              onChange={(e) => {
                const value = [e.target.value];
                handleSubPermission(value, permissionId, subPermission.type);
              }}
              value={option.value}
            >
              {option.label}
            </Radio>
          );
        })}
      </Space>
    </Radio.Group>
  );
};

const MultiSelectType = ({
  subPermission,
  toggleValue,
  permissionId,
  handleSubPermission,
  values,
}) => {
  const selectProps = {
    mode: "multiple",
    style: { width: "100%" },
    value: values,
    options: subPermission.defaults,
    onChange: (newValue) => {
      handleSubPermission(newValue, permissionId, subPermission.type);
    },
    optionLabelProp: "label",
    placeholder: "Select Item...",
    maxTagCount: "responsive",
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Select disabled={!toggleValue} {...selectProps} />
    </Space>
  );
};

const ListType = ({ subPermission, toggleValue }) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {subPermission.defaults.map((v, index) => {
        return (
          <LabelRow
            key={`ListType_${index}`}
            toggleValue={toggleValue}
            label={v.label}
          />
        );
      })}
    </Space>
  );
};

const GrantAllTag = ({ counts }) => {
  const isPartialAcess =
    counts.currentCount !== 0 && counts.currentCount < counts.totalCount;
  if (counts.currentCount === 0) return null;
  const label = isPartialAcess ? "PARTIAL" : "FULL";
  const bgColor = isPartialAcess ? "#828786" : "#363E3D";
  return (
    <div
      style={{
        height: 20,
        fontSize: 12,
        paddingTop: 2,
        paddingBottom: 2,
        paddingLeft: 8,
        paddingRight: 6,
        borderRadius: 2,
        color: "white",
        backgroundColor: bgColor,
      }}
    >
      {label}
    </div>
  );
};

const PermissionRow = ({
  data,
  currentData,
  handlePermissionToggle,
  handleSubPermission,
  isToggleDisabled,
  totalCountPerCategory,
  showTooltip,
}) => {
  const toggleValue = currentData.toggleValue;
  const showSubPermission =
    data.subPermission.type !== Utils.subPermissionType.NA;
  const counts = totalCountPerCategory[data.permissionType];
  const renderSubPermission = () => {
    if (data.subPermission.type === Utils.subPermissionType.RADIO)
      return (
        <RadioType
          subPermission={data.subPermission}
          toggleValue={toggleValue}
          permissionId={data.permissionId}
          handleSubPermission={handleSubPermission}
          values={currentData.subPermission.values}
          hasCataloguePermissions={
            totalCountPerCategory[Utils.CATALOGUE_PERMISSION].currentCount > 0
          }
        />
      );
    if (data.subPermission.type === Utils.subPermissionType.DROPDOWN_CHECKBOX)
      return (
        <MultiSelectType
          subPermission={data.subPermission}
          toggleValue={toggleValue}
          permissionId={data.permissionId}
          handleSubPermission={handleSubPermission}
          values={currentData.subPermission.values}
        />
      );
    if (data.subPermission.type === Utils.subPermissionType.LIST)
      return (
        <ListType
          subPermission={data.subPermission}
          toggleValue={toggleValue}
        />
      );
    return null;
  };

  const isGrantAll = data.slug.includes("grantAll_");

  return (
    <div
      style={{
        marginBottom: "1rem",
        flexDirection: "row",
        display: "flex",
        borderBottom: isGrantAll ? "1px solid #E6E7E7" : 0,
        opacity: isToggleDisabled ? "0.4" : "1",
      }}
    >
      <div>
        {showTooltip ? (
          <Tooltip
            placement="bottom"
            title={"Give user the access to view all products"}
          >
            <Switch
              checked={toggleValue}
              onChange={(e) => handlePermissionToggle(e, data)}
              name={data.permissionId}
              disabled={true}
            />
          </Tooltip>
        ) : (
          <Switch
            checked={toggleValue}
            onChange={
              isToggleDisabled
                ? () => {}
                : (e) => handlePermissionToggle(e, data)
            }
            name={data.permissionId}
            disabled={isToggleDisabled}
          />
        )}
      </div>
      <div
        style={{
          marginLeft: "1rem",
          flexDirection: "column",
          display: "flex",
        }}
      >
        <div style={{ flexDirection: "row", display: "flex" }}>
          <div
            style={{
              color: "#1D2624",
              fontWeight: 800,
              marginTop: 2,
              marginRight: 5,
            }}
          >
            {data.label}
          </div>
          {isGrantAll && <GrantAllTag counts={counts} />}
        </div>
        {data.subLabel && (
          <div style={{ color: "#686E6D" }}>{data.subLabel}</div>
        )}
        {isGrantAll && (
          <div style={{ color: "#686E6D" }}>
            {toggleValue
              ? "Turning this off will remove all permissions"
              : "Turn this on to give permissions"}
          </div>
        )}

        {showSubPermission && (
          <div style={{ marginTop: "1rem" }}>{renderSubPermission()}</div>
        )}
      </div>
    </div>
  );
};

export const EmployeePermissionsScreen = ({
  sideBarTabKey,
  data,
  types,
  handleSideBarTabChange,
  allPermissions,
  handlePermissionToggle,
  handleSubPermission,
  totalCountPerCategory,
  modalType,
}) => {
  const scrollToTop = () => {
    const node = document.getElementById("toggle-container");
    node.scrollTop = 0;
  };

  const permissions = data[sideBarTabKey - 1]?.permissions;
  const tabChange = (val) => {
    scrollToTop();
    handleSideBarTabChange(val);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    //animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div style={{ height: 400, display: "flex", flexDirection: "row" }}>
      <div style={{ height: "100%", flexGrow: 1, width: 380 }}>
        <CustomSideBar
          data={data}
          tabChange={tabChange}
          types={types}
          activeKey={sideBarTabKey}
          totalCountPerCategory={totalCountPerCategory}
          modalType={modalType}
          allPermissions={allPermissions}
        />
      </div>
      <div
        style={{
          height: "100%",
          marginLeft: 15,
          marginRight: 15,
          width: 1,
          backgroundColor: "#E6E7E7",
        }}
      />
      <div
        className="employee_screen"
        id="toggle-container"
        style={{ width: "100%", overflowY: "scroll" }}
      >
        {permissions?.map((p) => {
          const isToggleDisabled = Utils.evalIfToggleIsDisabled(
            p.parentDeps,
            allPermissions
          );
          const showTooltip = Utils.isCategoryDisabled(p, allPermissions);
          return (
            <>
              {p.permissionType === "Global" && (
                <div
                  style={{
                    marginBottom: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Lottie
                    options={defaultOptions}
                    height={"50%"}
                    width={"50%"}
                    //   isStopped={loading}
                    //   isPaused={loading}
                  />
                  <Text>You will have control to restrict access to price</Text>
                </div>
              )}
              <PermissionRow
                key={p.permissionId}
                handlePermissionToggle={handlePermissionToggle}
                handleSubPermission={handleSubPermission}
                data={p}
                currentData={allPermissions[p.permissionId]}
                isToggleDisabled={
                  isToggleDisabled || p.permissionType === "Global"
                }
                totalCountPerCategory={totalCountPerCategory}
                showTooltip={showTooltip}
              />
            </>
          );
        })}
      </div>
    </div>
  );
};
